module.exports = __webpack_public_path__ + "static/media/OMtmkr.4e0c6779.jpg";